export default function AboutSection() {
  return (
    <section id="poradnik" className="py-14 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-5">
              Czym jest Kakobuy Spreadsheet?
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
              <strong className="text-foreground-900">Kakobuy Spreadsheet</strong> to uporządkowana baza produktów, która pomaga użytkownikom szybciej znaleźć interesujące produkty z chińskich platform takich jak Taobao, Weidian oraz 1688. Arkusz zawiera setki starannie wyselekcjonowanych produktów z różnych kategorii — od obuwia i odzieży, przez akcesoria, aż po perfumy i wiele więcej.
            </p>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
              Dzięki <strong className="text-foreground-900">Kakobuy Spreadsheet</strong> nie musisz spędzać godzin na ręcznym przeszukiwaniu chińskich stron. Wszystkie produkty są posegregowane według kategorii, a każdy z nich zawiera bezpośredni link do strony zakupu, co znacznie przyspiesza i upraszcza cały proces.
            </p>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
              Niezależnie od tego, czy szukasz <strong className="text-foreground-900">najnowszych sneakersów</strong>, modnych bluz, eleganckich torebek czy unikalnych akcesoriów — <strong className="text-foreground-900">Kakobuy Spreadsheet</strong> jest Twoim kompleksowym przewodnikiem po świecie chińskich zakupów online.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Sprawdź Kakobuy Spreadsheet
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=Overhead%20shot%20of%20a%20bright%20modern%20home%20office%20desk%20setup%20featuring%20an%20open%20laptop%20showing%20colorful%20spreadsheet%20interface%20next%20to%20a%20ceramic%20vase%20with%20fresh%20tulips%20a%20handwritten%20notebook%20with%20product%20lists%20and%20a%20cup%20of%20green%20tea%20on%20a%20warm%20oak%20wood%20surface%20with%20soft%20morning%20light%20streaming%20through%20sheer%20beige%20curtains%20creating%20a%20productive%20yet%20serene%20atmosphere%20editorial%20workspace%20photography%20with%20organic%20textures%20and%20fresh%20spring%20tones&width=800&height=600&seq=about-kakobuy-illust-v2&orientation=landscape"
              alt="Kakobuy Spreadsheet - przegląd produktów"
              className="w-full rounded-2xl"
            />
            <div className="absolute -bottom-4 -right-4 w-24 h-24 md:w-32 md:h-32 bg-accent-100 rounded-2xl -z-10"></div>
            <div className="absolute -top-4 -left-4 w-16 h-16 md:w-20 md:h-20 bg-primary-100 rounded-2xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
}